module.exports = __webpack_public_path__ + "static/media/image4.fd7e9401.svg";